module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8c7iMOFtdq20unz+Ptgns7a6fSdxOHn8PjO4fBUl8t4rdbC2uxsptJzdiQpAAAAB3RSTlMAYL8AIM/vi50ITwAAAORJREFUeF7t2Fmqg0AUBuGe9O/ZIcn+txp96ddcsEC4WAv4IJhuj8ecWZcu5Kw/Mt6HKV1sCicU5nS5ORzQlIAmb2xCssYxkDMJ6j9DDxQhKHYGaqsQ6FWFQFlCoCIEipsQaO9CoFaFQFlCoEUIFIsQKHYhUFuFQK8qBMr63V+gIgSKmxBo70KgVoVAWUKgRQgUixgoARD100a5SvDjv/8POYpv6e5Dy18jo0+V6Kv2/st/VACIfEGO88IPEfePNeO8gKMfP4zy4zE/sPOfEEAP9EDUkgVb+1CLKGw1Ri7rjoj14Re3l688MahJ2wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2b05.png
// module id = 1417
// module chunks = 0